import React, { useState, useEffect  } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateFilledDataTemplateThunk,
} from "../../store/features/documentSlice";
import {
  updateShipmentIssue,
  updateRequiredActions,
} from "../../store/features/shipmentsSlice";
import SuccessMessageBox from "../Notification/Success";
import DynamicForm from "./DynamicForm";
const ExtractedInfo = ({ dataTemplate, threadId, documentId, shipmentId }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(dataTemplate); // Editable data state
  const { shipments, status: shipmentStatus } = useSelector((state) => state.shipments);
  const shipment = shipments.find((shipment) => shipment.thread_id === threadId);
  const { thread_id, case_number, documents, emailBodies} = shipment;
  const [isComplete, setIsComplete] = useState(false); // Save button state

  useEffect(() => {
    setData(dataTemplate);
  }, [threadId]);

  // Check if all fields are filled
  useEffect(() => {
    const checkCompletion = (obj) => {
      for (let key in obj) {
        if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
          if (!checkCompletion(obj[key])) return false;
        } else if (obj[key] === "" || obj[key] === "N/A" || obj[key] === "Not Applicable") {
          return false;
        }
      }
      return true;
    };

    setIsComplete(checkCompletion(data));
  }, [data]);


  // Handle input changes
  const handleChange = (path, value) => {
    const keys = path.split(".");

    // Create a deep copy of the data to avoid mutating the original
    const updatedData = { ...data };

    let ref = updatedData;

    keys.forEach((key, idx) => {
      if (idx === keys.length - 1) {
        // Update the value at the last key
        ref[key] = value;
      } else {
        // Ensure the intermediate key is a new object
        ref[key] = { ...ref[key] };
        ref = ref[key];
      }
    });

    setData(updatedData); // Update the state with the new object
  };

  // Recursive rendering of fields
  const renderFields = (obj, path = "") => {

    const formatKey = (key) => {
      return key
        // Add a space before uppercase letters not preceded by another uppercase letter
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        // Add a space between consecutive uppercase letters followed by lowercase letters
        .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
        // Capitalize the first letter
        .replace(/^./, (str) => str.toUpperCase());
    };
    return Object.keys(obj).map((key) => {
      const currentPath = path ? `${path}.${key}` : key;
      const value = obj[key];

      if (typeof value === "object" && !Array.isArray(value)) {
        return (
          <div key={currentPath} className="mb-6 border p-4 rounded bg-gray-50">
            <h4 className="font-bold text-gray-700 mb-2">{formatKey(key)}</h4>
            <div className="grid grid-cols-2 gap-4 ml-4">
              {renderFields(value, currentPath)}
            </div>
          </div>
        );
      } else if (Array.isArray(value)) {
        return (
          <div key={currentPath} className="mb-6">
            <h4 className="font-bold text-gray-700 mb-2">{formatKey(key)}</h4>
            {value.map((item, idx) => (
              <div
                key={`${currentPath}[${idx}]`}
                className="mb-4 border p-4 rounded bg-gray-50"
              >
                <h5 className="font-bold text-gray-600">Item {idx + 1}</h5>
                <div className="grid grid-cols-2 gap-4 ml-4">
                  {renderFields(item, `${currentPath}[${idx}]`)}
                </div>
              </div>
            ))}
          </div>
        );
      } else {
        const isIncomplete = value === "" || value === "N/A";
        return (
          <div key={currentPath} className="mb-4">
            <label className="block text-gray-600 mb-1">{formatKey(key)}</label>
            <input
              type="text"
              value={value}
              onChange={(e) => handleChange(currentPath, e.target.value)}
              className={`w-2/3 p-2 mr-4 border rounded ${
                isIncomplete ? "border-gray-300" : "border-gray-300"
              }`}
              placeholder={`Enter ${key}`}
            />
          </div>
        );
      }
    });
  };
  // const renderFields = (obj, path = "") => {
  //   const formatKey = (key) => {
  //     return key
  //       .replace(/([a-z])([A-Z])/g, "$1 $2")
  //       .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
  //       .replace(/^./, (str) => str.toUpperCase());
  //   };
  
  //   return (
  //     <div className="grid grid-cols-[repeat(auto-fit,minmax(240px,1fr))] gap-4">
  //       {Object.keys(obj).map((key) => {
  //         const currentPath = path ? `${path}.${key}` : key;
  //         const value = obj[key];
  
  //         if (typeof value === "object" && !Array.isArray(value)) {
  //           return (
  //             <div 
  //               key={currentPath} 
  //               className="col-span-full mb-4 border p-4 rounded bg-gray-50"
  //             >
  //               <h4 className="font-bold text-gray-700 mb-2">{formatKey(key)}</h4>
  //               {renderFields(value, currentPath)}
  //             </div>
  //           );
  //         } else if (Array.isArray(value)) {
  //           return (
  //             <div 
  //               key={currentPath} 
  //               className="col-span-full mb-4"
  //             >
  //               <h4 className="font-bold text-gray-700 mb-2">{formatKey(key)}</h4>
  //               {value.map((item, idx) => (
  //                 <div
  //                   key={`${currentPath}[${idx}]`}
  //                   className="mb-4 border p-4 rounded bg-gray-50"
  //                 >
  //                   <h5 className="font-bold text-gray-600 mb-2">Item {idx + 1}</h5>
  //                   {renderFields(item, `${currentPath}[${idx}]`)}
  //                 </div>
  //               ))}
  //             </div>
  //           );
  //         } else {
  //           const isIncomplete = value === "" || value === "N/A";
  //           return (
  //             <div key={currentPath} className="min-w-[240px]">
  //               <label className="block text-gray-600 mb-1 text-sm font-medium">
  //                 {formatKey(key)}
  //               </label>
  //               <input
  //                 type="text"
  //                 value={value}
  //                 onChange={(e) => handleChange(currentPath, e.target.value)}
  //                 className="w-full px-3 py-2 border rounded-md border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
  //                 placeholder={`Enter ${key}`}
  //               />
  //             </div>
  //           );
  //         }
  //       })}
  //     </div>
  //   );
  // };


  const [showSuccessMessage, setShowSuccessMessage] = useState(false); // State for success message visibility
  const handleSave = async () => {
    // Dispatch Redux actions to update the filled data template and persist globally
    await dispatch(updateFilledDataTemplateThunk({ caseNumber:case_number, documentId, extractedInfo:data }));
    console.log("updated data",data)
  };
  // Handle Save Function
  const handleSaveClick = async () => {
    try {
        await handleSave(); // Call save function
        setShowSuccessMessage(true); // Show success popup

        // Automatically hide the message after 3 seconds
        setTimeout(() => setShowSuccessMessage(false), 3000);
    } catch (error) {
        console.error("Failed to save amends:", error);
        alert("Failed to save amends. Please try again.");
    }
};

  return (
  <div className="relative bg-bg p-1 flex  rounded-md  flex-col h-full">
            {/* Rendering Area */}
            <div className="flex-grow overflow-y-auto m-2 p-1 bg-bg">
                <h3 className="font-bold text-lg mb-4">Extracted Information</h3>
                {/* Render data fields */}
                {renderFields(data)}
                {/* <DynamicForm data={data} onChange={handleChange} /> */}
            </div>

            {/* Fixed Footer Area (OUTSIDE Scrolling Section) */}
            <div className="flex justify-end items-center pb-2 pr-2 bg-white">
                {/* Save Amends Button with Tooltip */}
                <div className="relative group">
                    <button
                        onClick={handleSaveClick} // Updated to use handleSaveClick
                        className={`px-4 p-2 text-logo rounded-full transition-all bg-bg border border-logo text-logo hover:bg-logo hover:text-white
                                `}
                    >
                        Save Amends
                    </button>

                    {/* Tooltip - Appears only when button is disabled */}
                    {/* {!isComplete && (
                        <div
                            className="fixed z-50 pb-4 p-2 text-sm text-white bg-gray-800 rounded-md shadow-lg hidden group-hover:block"
                            style={{
                                top: 'calc(100% - 150px)', // Adjust this to position it above the button
                                right: '50px', // Keeps it aligned to the right corner
                                width: '300px',
                            }}
                        >
                            Please fill all required fields.
                            If information is unavailable, proceed to send the draft email.
                        </div>
                    )} */}
                </div>
            </div>

            {/* Success Message Popup */}
            {showSuccessMessage && (
                <SuccessMessageBox
                  message="successfully updated"
                />
            )}
        </div>
  );
};

export default ExtractedInfo;